"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation patchUserService(
        $patch: UserPatch!
        $userId: Int!
        $includeCorpCollections: Boolean!
        $includeRetailCollections: Boolean!
    ) {
        updateUser(input: { patch: $patch, userId: $userId }) {
            user {
                userId
                identityProviderId
                identityProviderUserId
                firstName
                lastName
                phone
                preferredContactMethod
                preferredContactTime
                preferredPronouns
                zipcode: zipCode
                optInCall
                optInEmail
                optInText
                preferredName
                suffix
                retailCollections @include(if: $includeRetailCollections) {
                    nodes {
                        id: retailCollectionId
                        label
                        inventoryItems {
                            nodes {
                                id: retailCollectionInventoryItemId
                                collectionId: retailCollectionId
                                modelNumber
                                serialNumber
                            }
                        }
                    }
                }
                corpCollections @include(if: $includeCorpCollections) {
                    nodes {
                        id: corpCollectionId
                        label
                        collectionModels {
                            nodes {
                                id: corpCollectionModelId
                                collectionId: corpCollectionId
                                modelNumber
                            }
                        }
                    }
                }
            }
        }
    }
`;exports.patchUser=e;
//# sourceMappingURL=queries.js.map
